<template>
    <div>
        <div v-if="contactForm.successful">
            <h5 class="text-white">Thank you for contacting us!</h5>
        </div>
        <div v-else>
            <h5 class="h5 mb-8 text-white" style="font-weight: 700;">Send a Message</h5>
            <form
                id="contact-form"
                class="input-glass"
                :action="contactStoreRoute"
                method="POST"
                @submit.prevent="submit"
                validate
            >
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <input
                            id="contact_name"
                            v-model="contactForm.contact_name"
                            type="text"
                            maxlength="100"
                            minlength="2"
                            class="form-control"
                            :class="{ 'is-invalid' : contactForm.errors.has('contact_name') }"
                            name="name"
                            placeholder="Your name"
                            required>
                        <div
                            v-if="contactForm.errors.has('contact_name')"
                            class="invalid-feedback"
                            v-text="contactForm.errors.get('contact_name')"
                        >
                        </div>
                    </div>
                </div>
                <div class="form-row" style="display:none;">
                    <div class="form-group col-md-12">
                        <input
                            v-model="contactForm.email"
                            id="email"
                            type="email"
                            class="form-control"
                            name="email">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <input
                            v-model="contactForm.contact_email"
                            id="contact_email"
                            type="text"
                            maxlength="100"
                            minlength="5"
                            class="form-control"
                            :class="{ 'is-invalid' : contactForm.errors.has('contact_email') }"
                            name="contact_email"
                            placeholder="Your email address"
                            required>
                        <div
                            v-if="contactForm.errors.has('contact_email')"
                            class="invalid-feedback"
                            v-text="contactForm.errors.get('contact_email')"
                        >
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <the-mask
                            id="contact_phone"
                            v-model="contactForm.contact_phone"
                            :mask="['(###) ###-####']"
                            :masked=true
                            class="form-control"
                            :class="{ 'is-invalid' : contactForm.errors.has('contact_phone') }"
                            name="contact_phone"
                            placeholder="Your phone number"
                            maxlength="20"
                            required
                        >
                        </the-mask>
                        <div
                            v-if="contactForm.errors.has('contact_phone')"
                            class="invalid-feedback"
                            v-text="contactForm.errors.get('contact_phone')"
                        >
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col">
                        <textarea
                            v-model="contactForm.contact_message"
                            id="contact_message"
                            maxlength="5000"
                            rows="5"
                             class="form-control"
                            :class="{ 'is-invalid' : contactForm.errors.has('contact_message') }"
                            name="message"
                            placeholder="How can we help?"
                            required
                        ></textarea>
                        <div
                            v-if="contactForm.errors.has('contact_message')"
                            class="invalid-feedback"
                            v-text="contactForm.errors.get('contact_message')"
                        >
                        </div>
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col">
                        <button
                            v-if="contactForm.busy"
                            class="btn btn-primary btn-block transition-hover disabled"
                            type="button"
                            style="width:100%;"
                            disabled
                        >Processing...</button>
                        <button 
                            v-else 
                            type="submit" 
                            class="btn btn-primary btn-block transition-hover"
                        >Get in Touch</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    // import VueRecaptcha from 'vue-recaptcha';
    import {TheMask} from 'vue-the-mask';

    export default {
        mounted() {
            this.initializeForm();
            this.contactForm.form_start = Date.now();
        },
        components: {
            // VueRecaptcha
            TheMask,
        },
        props: {
            contactStoreRoute: {
                type: String
            },
            recaptchaPublicKey: {
                type: String,
                default: null
            }
        },
        /**
         * The component's data.
         */
        data() {
            return {
                contactForm: new SparkForm({
                    _token: null,
                    g_recaptcha_response: null,
                    form_start: null,
                    contact_name: '',
                    contact_email: '',
                    contact_phone: '',
                    contact_message: ''
                })
            }
        },
        methods: {
            initializeForm() {
                
                axios.get('/api/token')
                    .then(
                        (response) => {
                            this.contactForm._token = response.data;
                        },
                        (error) => {
                            console.log(error);
                        }
                    )
            },
            submit: function () {
                console.log('submitting');
                // this.status = "submitting";
                // this.$refs.recaptcha.execute();
                this.onCaptchaVerified('token');
            },
            onCaptchaVerified: function (recaptchaToken) {
                let self = this;
                self.status = "submitting";
                // self.$refs.recaptcha.reset();

                self.contactForm.g_recaptcha_response = recaptchaToken;

                Spark.post(self.contactStoreRoute, self.contactForm)
                        .then( function(response) {
                            self.form_successful = true;
                            console.log(response);
                            swal(response.status, response.message, 'success');
                        })
                        .catch( function(error) {
                            console.log(error);
                            self.form_successful = false;
                            if (error.message == 'The given data was invalid.') {
                                swal({   
                                    title: 'Forms errors found',
                                    text: 'Please check your form for errors.',
                                    icon: 'error',
                                    button: "Ok",
                                });
                            } else {
                                swal({   
                                    title: 'Unable to save form',
                                    text: error,
                                    icon: 'error',
                                    button: "Ok",
                                });
                            };
                        });
            },
            // onCaptchaExpired: function () {
            //     this.$refs.recaptcha.reset();
            // }
        }
    }
</script>